/**
 * Image paths by locale.
 *
 * - Shared (logos, fonds, badges) → `/public/images/{file}` — do NOT duplicate in fr/en
 * - Screenshots with UI text → `/public/images/{fr|en}/{file}`
 *
 * When adding a new localized screenshot: put it in both fr/ and en/, then add
 * the filename to LOCALIZED_SCREENSHOTS. If EN is not ready yet, add it to EN_MISSING.
 */

/** Filenames under public/images/fr and/or public/images/en */
const LOCALIZED_SCREENSHOTS = new Set([
  'earit_screen_settings.png',
  'safetizen_screen_alert_ended.png',
  'safetizen_screen_alert_is_joined.png',
  'safetizen_screen_alert_is_sending.png',
  'safetizen_screen_alert_notif.png',
  'safetizen_screen_alert_supported.png',
  'safetizen_screen_false_alert_timer.png',
  'safetizen_screen_gps_permission.png',
  'safetizen_screen_help_alert.png',
  'safetizen_screen_home_with_privacy_mode.png',
  'safetizen_screen_notifs_permission.png',
  'safetizen_screen_records.png',
  'safetizen_screen_verbal_assault_notif.png',
  'safetizen_screen_widget.png',
]);

/** In FR but not yet in EN — serve FR until the EN asset exists */
const EN_MISSING = new Set(['safetizen_screen_alert_is_sending.png']);

function basename(pathOrFilename: string): string {
  return pathOrFilename
    .replace(/^\/images\/(fr|en)\//, '')
    .replace(/^\/images\//, '');
}

/** Resolves a shared or localized image path for the active locale. */
export function imageSrc(locale: string, pathOrFilename: string): string {
  const filename = basename(pathOrFilename);
  if (!LOCALIZED_SCREENSHOTS.has(filename)) {
    return `/images/${filename}`;
  }
  let loc = locale === 'en' ? 'en' : 'fr';
  if (loc === 'en' && EN_MISSING.has(filename)) {
    loc = 'fr';
  }
  return `/images/${loc}/${filename}`;
}

/** Maps a list of image paths through {@link imageSrc}. */
export function imageSrcList(locale: string, paths: string[]): string[] {
  return paths.map((p) => imageSrc(locale, p));
}
